import React from 'react';
import { IconRss } from '../../../../ui-kit/icons.js';

const WaitingForIncidentMessage = () => (
  <div className="h-100 d-flex align-items-center">
    <div className="w-100">
      <h1 className="display-1 text-center">
        <IconRss />
      </h1>
      <h4 className="text-center">{I18n.t('dashboards.widget_archetypes.shared.listening_for_incidents')}</h4>
    </div>
  </div>
);

export default WaitingForIncidentMessage;
